import React, { Component }                from 'react'
import Checkbox                              from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

export class LabeledCheckbox extends Component{

  render = () => {
    const {fullWidth, label, error, helperText, ...props } = this.props
    return (
      <FormControl fullWidth={!!fullWidth} error={!!error}>
        <FormControlLabel
            label={label}
            control={
              <Checkbox checked={`${props.value}`==='true'} type='checkbox' {...props}/>
            }
          />
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    )
  }

}

export default LabeledCheckbox